var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_container"},[_c('img',{staticStyle:{"width":"1px","height":"1px"},attrs:{"id":"image","src":_vm.imageurl,"alt":"Picture"}})])}
var staticRenderFns = []

export { render, staticRenderFns }